type ColumnHeaderProps = {
  label: string
  value?: string
  color?: string
}

export function ColumnHeader({ label, value, color }: ColumnHeaderProps) {
  return (
    <div className="flex min-h-[59px] flex-col items-stretch rounded-md border border-muted-foreground/20 bg-muted/30 px-3 py-2">
      <div className="flex items-center gap-2 border-b pb-1">
        <span className="truncate text-xs font-medium text-muted-foreground">{label}</span>
      </div>
      {value && (
        <div className="flex items-center gap-2 pt-1">
          <span
            className="inline-block h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: color ?? '#64748b' }}
          />
          <span className="truncate text-xs font-medium">{value}</span>
        </div>
      )}
    </div>
  )
}
